import api from "./api";

class VoceSpesaManager {

    vociSpesa(config?: any) {
        return api.get(`/voci_spesa`, config)
    }

    voceSpesa(id: number | string) {
        return api.get(`/voci_spesa/${id}`)
    }

    voceSpesaDefaultIva(id: number | string, business_unit_id: number | string){
        return api.get(`/voci_spesa/${id}/business_unit/${business_unit_id}`)
    }

    list = this.vociSpesa
    retrieve = this.voceSpesa
}

const voceSpesaManager = new VoceSpesaManager()

export default voceSpesaManager
